export const load = () => ({
	title: 'Reduce Train Noise with Office Soundproofing',
	showTitle: true,
});
